import React from "react";
import { toggle } from "../../../../util/common";
import TradePaymentDbt from "./TradePaymentDbt";
import TradePaymentPayDayScore from "./TradePaymentPayDayScore";
import TradePaymentMonthlyDbtTrends from "./TradePaymentMonthlyDbtTrends";
import TradePaymentData from "./TradePaymentData";
import { IBusinessCreditReportResponse, BusinessCreditReportStatePII } from "../../../../store/businessCreditReportService/types";

interface IProps {
    bCreditReportData: IBusinessCreditReportResponse;
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
    creditProvider?: any;
}
const TradePayment: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div className="drawer-container">
                <div className="drawer-header">
                    {props.showAsAccordion ? (
                        <button
                            aria-expanded="false"
                            className="btn-default btn-toggle btn-drawer"
                            id="btn-trade-payment"
                            onClick={() => toggle("trade-payment", "btn-trade-payment")}
                        >
                            <span className="btn-toggle-status sr-only">Show</span>
                            <span className="btn-text">Trade Payment</span>
                        </button>
                    ) : (
                        <h3>Trade Payment</h3>
                    )}
                </div>

                <div className="drawer-content" id="trade-payment" style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }}>
                    <div role="list" className="data-grid has-lines margin-top-s" id="">
                        <div role="listitem" className="data-row">
                            {props.creditProvider === "DUNBRADSTREET" && (
                                <TradePaymentPayDayScore
                                    bCreditReportData={props.bCreditReportData}
                                    reportObject={props.reportObject}
                                    showAsAccordion={props.showAsAccordion}
                                />
                            )}
                            {props.creditProvider !== "DUNBRADSTREET" && (
                                <TradePaymentDbt
                                    bCreditReportData={props.bCreditReportData}
                                    reportObject={props.reportObject}
                                    showAsAccordion={props.showAsAccordion}
                                />
                            )}
                            {props.creditProvider !== "DUNBRADSTREET" && (
                                <TradePaymentMonthlyDbtTrends
                                    bCreditReportData={props.bCreditReportData}
                                    reportObject={props.reportObject}
                                    showAsAccordion={props.showAsAccordion}
                                />
                            )}
                            <TradePaymentData reportObject={props.reportObject} showAsAccordion={props.showAsAccordion} />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default TradePayment;
